import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgLeft({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.011 12.149l-.008-.067L5 11.981l.004-.07.016-.112.03-.111.044-.111.052-.098.067-.096a.998.998 0 01.08-.09l6-6a1 1 0 011.497 1.32l-.083.094L8.413 11H18a1 1 0 01.993.883L19 12a1 1 0 01-.883.993L18 13H8.414l4.293 4.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083-6-6-.043-.046-.054-.066-.071-.11-.054-.114-.035-.105-.025-.117z"
        fill={color}
      />
    </svg>
  )
}

export default SvgLeft
